import $ from 'jquery';

export default {

  extend(dest, ...objs) {
    for (const obj in objs) {
      for (const k in objs[obj]) {
        const v = objs[obj][k];
        dest[k] = v;
      }
    }
    return dest;
  },

  windowWidth() {
    return window.innerWidth || this.window.width();
  },

  debounce(func, wait, immediate) {
    let timeout = null;
    return function () {
      const context = this;
      const args = arguments;

      const later = function () {
        timeout = null;
        if (!immediate) {
          func.apply(context, args);
        }
      };

      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);

      if (callNow) {
        func.apply(context, args);
      }
    };
  },

  inViewport(el) {
    // special bonus for those using jQuery
    if ((typeof $ === 'function') && el instanceof $) {
      el = el[0];
    }

    const rect = el.getBoundingClientRect();

    const bounds = {
      top: rect.top >= 0,
      bottom: rect.bottom <= (window.innerHeight || document.documentElement.clientHeight),
    };

    return bounds.top && bounds.bottom;
  },

  unique(array) {
    let key;
    let asc; let
      end;
    const output = {};
    for (key = 0, end = array.length, asc = end >= 0; asc ? key < end : key > end; asc ? key++ : key--) { output[array[key]] = array[key]; }
    return (() => {
      const result = [];
      for (key in output) {
        const value = output[key];
        result.push(value);
      }
      return result;
    })();
  },
};
